<template>
  <div id="app">
   <!-- <transition :name="direction">-->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!--</transition>-->
  </div>
</template>

<script>

  export default {
    name: 'app',
    /*data:() => ({
      direction: "slide-right"
    }),
    watch: {
      $route(to, from) {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        if (to.path == "/") {
          this.direction = "slide-right";
        } else if (from.path == "/") {
          this.direction = "slide-left";
        }else{
          this.direction = toDepth < fromDepth ? "slide-right" : "slide-left";
        }
      }
    }*/
  }
</script>

<style lang="css" >
  #app {
    overflow-x:hidden;
    width: 100%;
    height: 100%;
    transition: transform 0.3s ease-out;
    box-sizing: border-box;
  }
  html {
     min-height: 100%;
     _height:100%;
     height:100%;
     /*background-image: url("assets/images/background.png");
     background-size: 100% 100%;
     background-repeat: no-repeat;*/
     z-index: -99999;
   }
  /*body {
    width: 100%;
    height: 100%;
  }*/
  * {
    margin: 0;
    padding: 0;
  }
  ul,li{
    list-style: none;
  }
  a{
    text-decoration: none;
  }
  .slide-left-enter{
    transform: translate(100%, 0);
  }
  .slide-left-leave-active{
    transform: translate(-50%, 0);
  }
  .slide-right-enter {
    transform: translate(-50%, 0);
  }
  .slide-right-leave-active{
    transform: translate(100%, 0);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue